// @ts-strict-ignore
import {Component, Injector} from "@angular/core";
import {MEDIA_DIALOG_BASE_INPUT} from "../media-image-dialog/media-image-dialog.component";
import {SimUtilityExtendedService} from "@services";
import {BasicMaterialDialog} from "../../basic-material-dialog/basic-material-dialog.directive";

@Component({
	selector: "sim-media-video-dialog",
	templateUrl: "./media-video-dialog.component.html",
	styleUrls: ["./media-video-dialog.component.scss"],
	standalone: false,
})
export class MediaVideoDialogComponent extends BasicMaterialDialog<MediaVideoDialogComponent, MEDIA_DIALOG_BASE_INPUT> {
	public mediaUrl: string;

	constructor(
		_injector: Injector,
		private _simUtilityService: SimUtilityExtendedService,
	) {
		super(_injector);
	}

	ngOnInit() {
		super.ngOnInit();
		this.mediaUrl = this._simUtilityService.getMediaPath(this.data.media);
	}

	public stop() {
		this.close({action: "ok"});
	}

	public cancel() {
		this.close({action: "cancel"});
	}
}
